import React from 'react';
import { Route, IndexRoute, Redirect } from 'react-router';

import SectionPlainTitle from 'modules/Common/components/SectionPlainTitle';

import HorseRacingBase from './components/HorseRacingBase';

import HorseRacingHomePage from './containers/HorseRacingHomePage';

import HorseRacingFastCardsPage from './containers/HorseRacingFastCardsPage';
import HorseRacingRacecardsPage from './containers/HorseRacingRacecardsPage';

import HorseRacingMostFollowed from './containers/HorseRacingMostFollowed';

import HorseRacingNonRunnersPage from './containers/HorseRacingNonRunnersPage';
import HorseRacingNonRunnersContainer from './containers/HorseRacingNonRunnersContainer';

import HorseRacingGoingPage from './containers/HorseRacingGoingPage';
import HorseRacingGoingContainer from './containers/HorseRacingGoingContainer';

import HorseRacingResultsPage from './containers/HorseRacingResultsPage';
import HorseRacingFastResultsPage from './containers/HorseRacingFastResultsPage';
import HorseRacingMeetingLandingPage from './containers/HorseRacingMeetingLandingPage';
import HorseRacingEarlyEntriesPage from './containers/HorseRacingEarlyEntriesPage';
import HorseRacingRichardFaheyPage from './containers/HorseRacingRichardFaheyPage';
import HorseRacingProfilePage from './containers/HorseRacingProfilePage';
import NapsTablePage from './containers/NapsTablePage';
import HorseRacingAbcGuidePage from './containers/HorseRacingAbcGuidePage';

import HorseRacingRacePageContainer from './containers/HorseRacingRacePageContainer';
import HorseRacingFastCards from './containers/HorseRacingFastCards';
import HorseRacingRacecardsForDateContainer from './containers/HorseRacingRacecardsForDateContainer';
import HorseRacingFastResults from './containers/HorseRacingFastResults';
import HorseRacingMeetingLandingContainer from './containers/HorseRacingMeetingLandingContainer';
import HorseRacingEarlyEntriesContainer from './containers/HorseRacingEarlyEntriesContainer';
import HorseRacingResultsForDateContainer from './containers/HorseRacingResultsForDateContainer';
import NapsTable from './containers/NapsTable';
import HorseRacingAbcGuide from './containers/HorseRacingAbcGuide';

import MyStablePageContainer from './containers/MyStablePageContainer';
import MyStablePage from './containers/MyStablePage';

import MyStableSearchResults from './containers/MyStableSearchResults';
import MyStableSelections from './containers/MyStableSelections';
import MyStableNextEntries from './containers/MyStableNextEntries';
import MyStableResults from './containers/MyStableResults';
import MyStableEmailUnsubscribe from './containers/MyStableEmailUnsubscribe';

import InsightsPage from './containers/InsightsPage';
import InsightDescriptionsContainer from './containers/InsightDescriptionsContainer';

import HorseRacingTipsCentre from './containers/HorseRacingTipsCentre';

import HorseRacingRacecardPage from './components/HorseRacingRacecardPage';
import HorseRacingLiveShowPage from './components/HorseRacingLiveShowPage';

import HorseRacingNav from './nav/HorseRacingNav';
import MoreNews from 'modules/News/containers/MoreNews';
import MostReadRacing from 'modules/Common/containers/MostReadRacing';

import HorseProfilePageContainer from './containers/Profiles/HorseProfilePageContainer';
import HorseProfileResultsPage from './components/Profiles/HorseProfileResultsPage';
import HorseProfileEntriesPage from './components/Profiles/HorseProfileEntriesPage';

import JockeyProfilePageContainer from './containers/Profiles/JockeyProfilePageContainer';
import JockeyProfileResultsPage from './components/Profiles/JockeyProfileResultsPage';
import JockeyProfileEntriesPage from './components/Profiles/JockeyProfileEntriesPage';

import TrainerProfilePageContainer from './containers/Profiles/TrainerProfilePageContainer';
import TrainerProfileResultsPage from './components/Profiles/TrainerProfileResultsPage';
import TrainerProfileEntriesPage from './components/Profiles/TrainerProfileEntriesPage';

import HorseRacingNextRaceOff from 'modules/Common/containers/HorseRacingNextRaceOff';
import RacingTips from 'modules/Common/containers/RacingTips';

import AdvertWrapper from 'modules/Common/components/AdvertWrapper';
import GooglePublisherTag from 'modules/Common/containers/GooglePublisherTag';

import ArticleContainer from 'modules/News/containers/ArticleContainer';
import Article from 'modules/News/components/Article';
import { newsArticleExpander } from 'modules/News/sitemap-helper.js';
import GptAdvert from 'modules/Common/components/GptAdvert';

import { racecardForDatesExpander,
          resultsExpander,
          racecardExpander,
          abcDaysExpander,
          abcTypeExpander,
          abcFiveDayExpander } from './sitemap-helper.js';

const HorseRacingSideBarComponentsNoTips = {
  GooglePublisherTag,
  HorseRacingNextRaceOff,
  AdvertWrapper
}

const HorseRacingSideBarComponents = {
  ...HorseRacingSideBarComponentsNoTips,
  RacingTips
}

const HorseRacingHomePageComponents = {
  MoreNews,
  AdvertWrapper,
  GptAdvert,
  MostReadRacing,
  ...HorseRacingSideBarComponents
}

const HorseRacingFastResultsPageComponents = {
  HorseRacingFastResults,
  HorseRacingMostFollowed,
  ...HorseRacingSideBarComponents
}

const InsightsPageComponents = {
  InsightDescriptionsContainer,
  ...HorseRacingSideBarComponents
}

const HorseRacingMeetingLandingPageComponents = {
  HorseRacingMeetingLandingContainer,
  ...HorseRacingSideBarComponents
}

const HorseRacingNonRunnersPageComponents = {
  HorseRacingNonRunnersContainer,
  ...HorseRacingSideBarComponents
}

const HorseRacingGoingPageComponents = {
  HorseRacingGoingContainer,
  ...HorseRacingSideBarComponents
}

const HorseRacingRacecardsPageComponents = {
  HorseRacingRacecardsForDateContainer,
  HorseRacingMostFollowed,
  ...HorseRacingSideBarComponents
}

const HorseRacingRacePageComponents = {
  HorseRacingRacePageContainer,
  HorseRacingMostFollowed,
  ...HorseRacingSideBarComponents
}

const HorseRacingFastCardsPageComponents = {
  HorseRacingFastCards,
  ...HorseRacingSideBarComponents
}

const HorseRacingResultsPageComponents = {
  HorseRacingResultsForDateContainer,
  HorseRacingMostFollowed,
  ...HorseRacingSideBarComponents
}

const HorseRacingEarlyEntriesPageComponents = {
  HorseRacingEarlyEntriesContainer,
  ...HorseRacingSideBarComponents
}

const HorseProfilePageComponents = {
  ProfilePageContainer: HorseProfilePageContainer,
  ...HorseRacingSideBarComponents
}

const TrainerProfilePageComponents = {
  ProfilePageContainer: TrainerProfilePageContainer,
  ...HorseRacingSideBarComponents
}

const JockeyProfilePageComponents = {
  ProfilePageContainer: JockeyProfilePageContainer,
  ...HorseRacingSideBarComponents
}

const RichardFaheyPageComponents = {
  MoreNews,
  SectionPlainTitle,
  MostReadRacing,
  ...HorseRacingSideBarComponents
}

const TipsCentrePageComponents = {
  MoreNews,
  MostReadRacing,
  HorseRacingMostFollowed,
  ...HorseRacingSideBarComponentsNoTips
}

const MyStablePageComponents = {
  MyStablePageContainer,
  HorseRacingMostFollowed,
  ...HorseRacingSideBarComponents
}

const HorseRacingArticleComponents = {
  Article,
  MostReadRacing,
  ...HorseRacingSideBarComponents
}

const NapsTableComponents = {
  NapsTable,
  HorseRacingMostFollowed,
  ...HorseRacingSideBarComponents
}

const AbcGuideComponents = {
  HorseRacingAbcGuide,
  HorseRacingMostFollowed,
  ...HorseRacingSideBarComponents
}

const horseRacingRoutes = (
  <Route path="racing" component={HorseRacingBase} subnav={HorseRacingNav}>
    <Redirect path="fast%20results" to="fast-results"/>
    <Route component={HorseRacingHomePage}> {/*Has Layout Manager*/}
      <IndexRoute sitemap={{}} components={HorseRacingHomePageComponents}/> {/*Has Layout*/}
    </Route>
    <Route path="going" component={HorseRacingGoingPage}> {/*Has Layout Manager*/}
      <IndexRoute sitemap={{}} components={HorseRacingGoingPageComponents}/> {/*Has Layout*/}
    </Route>
    <Route path="non-runners" component={HorseRacingNonRunnersPage}> {/*Has Layout Manager*/}
      <IndexRoute sitemap={{}} components={HorseRacingNonRunnersPageComponents}/> {/*Has Layout*/}
    </Route>
    <Route path="fast-cards/:meetingId/:date/:courseSlug" component={HorseRacingFastCardsPage}> {/*Has Layout Manager*/}
      <IndexRoute components={HorseRacingFastCardsPageComponents}/> {/*Has Layout*/}
    </Route>
    <Route path="racecards" component={HorseRacingRacecardsPage}> {/*Has Layout Manager*/}
      <IndexRoute sitemap={{}} components={HorseRacingRacecardsPageComponents}/> {/*Has Layout*/}
      <Route sitemap={{expand: racecardForDatesExpander}} path=":date" components={HorseRacingRacecardsPageComponents}/> {/*Has Layout*/}
      <Route path=":date/:courseSlug" components={HorseRacingRacePageComponents} result-racecard="racecard">
        <Route path="racecard/:raceId/:raceSlug" sitemap={{changefreq: "always", priority: 0.5, expand: racecardExpander}} component={HorseRacingRacecardPage} result-racecard="racecard"/> {/*Has Layout*/}
        <Route path="live-show/:raceId/:raceSlug" component={HorseRacingLiveShowPage} /> {/*Has Layout*/}
      </Route>
    </Route>
    <Route path="fast-results" component={HorseRacingFastResultsPage} > {/*Has Layout Manager*/}
      <IndexRoute sitemap={{}} components={HorseRacingFastResultsPageComponents} filterResults={true} /> {/*Has Layout*/}
      <Route path="all" sitemap={{}} components={HorseRacingFastResultsPageComponents} filterResults={false} /> {/*Has Layout*/}
      <Redirect path=":meetingDate/:meetingName/:meetingId" to="/racing/meeting/:meetingDate/:meetingName/:meetingId"/> {/* legacy meeting fast results page */}
    </Route>
    <Route path="meeting/:meetingDate/:meetingName/:meetingId" component={HorseRacingMeetingLandingPage}> {/*Has Layout Manager*/}
      <IndexRoute components={HorseRacingMeetingLandingPageComponents}/>
    </Route>
    <Route path="results" component={HorseRacingResultsPage}> {/*Has Layout Manager*/}
      <IndexRoute sitemap={{}} components={HorseRacingResultsPageComponents}/> {/*Has Layout*/}
      <Route path=":date" sitemap={{expand: resultsExpander}} components={HorseRacingResultsPageComponents}/> {/*Has Layout*/}
      <Route path=":date/:courseSlug/:raceId/:raceSlug" components={HorseRacingRacePageComponents} result-racecard="result">
        <IndexRoute component={HorseRacingRacecardPage} result-racecard="result"/> {/*Has Layout*/}
      </Route>
    </Route>
    <Route path="early-entries" component={HorseRacingEarlyEntriesPage}> {/*Has Layout Manager*/}
      <IndexRoute sitemap={{}} components={HorseRacingEarlyEntriesPageComponents}/> {/*Has Layout*/}
    </Route>
    <Route path="profiles" component={HorseRacingProfilePage}> {/*Has Layout Manager*/}
      <Route path="horse/:horseId" components={HorseProfilePageComponents}>
        <IndexRoute component={HorseProfileResultsPage}/> {/*Has Layout*/}
        <Route path="future-entries" component={HorseProfileEntriesPage}/> {/*Has Layout*/}
      </Route>
      <Route path="jockey/:jockeyId" components={JockeyProfilePageComponents}>
        <IndexRoute component={JockeyProfileResultsPage}/>
        <Route path="future-entries" component={JockeyProfileEntriesPage}/>
      </Route>
      <Route path="trainer/:trainerId" components={TrainerProfilePageComponents}>
        <IndexRoute component={TrainerProfileResultsPage}/>
        <Route path="future-entries" component={TrainerProfileEntriesPage}/>
      </Route>
    </Route>
    <Route path="my-stable" component={MyStablePage}>  {/* layout manager */}
      <Route components={MyStablePageComponents}>
        <IndexRoute sitemap={{}} component={MyStableNextEntries}/> {/* layout */}
        <Route sitemap={{}} path="results" component={MyStableResults}/> {/* layout */}
        <Route sitemap={{}} path="selections" component={MyStableSelections}/> {/* layout */}
        <Route sitemap={{}} path="search" component={MyStableSearchResults}/> {/* layout */}
        <Route sitemap={{}} path="unsubscribe" component={MyStableEmailUnsubscribe}/> {/* layout */}
      </Route>
    </Route>
    <Route path="columnists">
      <Route path="richard-fahey" component={HorseRacingRichardFaheyPage}> {/* layout manager */}
        <IndexRoute sitemap={{}} components={RichardFaheyPageComponents}/> {/* layout */}
      </Route>
    </Route>
    <Route path="tips-centre" component={HorseRacingTipsCentre}> {/* layout manager */}
      <IndexRoute sitemap={{}} components={TipsCentrePageComponents}/> {/* layout */}
    </Route>
    <Redirect path="news/going/37632" to="going"/> {/* legacy of going in an article */}
    <Route path="news/:title/:articleId"
           component={ArticleContainer}
           sport="racing"
           rightHandContent={['mostReadRacing', 'topMpu', 'horseRacingNextRaceOffAll', 'racingTips', 'bottomMpu', 'ocWidget']}>{/* layout manager */}
      <IndexRoute sitemap={{expand: newsArticleExpander("racing")}} components={HorseRacingArticleComponents}/> {/* layout */}
    </Route>
    <Route path="naps-table" component={NapsTablePage}> {/* layout manager */}
      <IndexRoute sitemap={{}} components={NapsTableComponents}/> {/* layout */}
    </Route>
    <Route path="abc-guide" component={HorseRacingAbcGuidePage}> {/* layout manager */}
      <IndexRoute sitemap={{}} components={AbcGuideComponents}/> {/* layout */}
      <Route path=":days" components={AbcGuideComponents}>
        {/* No components because it's all in the HorseRacingAbcGuide component from the parent */}
        <IndexRoute sitemap={{expand: abcDaysExpander}}/>
        <Route path=":type">
          <IndexRoute sitemap={{expand: abcTypeExpander}}/>
          <Route path=":letterRange" sitemap={{expand: abcFiveDayExpander}}/>
        </Route>
      </Route>
    </Route>
    <Route path="insights" component={InsightsPage}> {/* layout manager */}
      <IndexRoute sitemap={{}} components={InsightsPageComponents}/> {/* layout */}
    </Route>
  </Route>
)

export default horseRacingRoutes



// WEBPACK FOOTER //
// ./modules/HorseRacing/routes.js